import { useMemo } from "react"
import { useApiClient } from "@/providers/ApiClientProvider"
import { createAuthService } from "@/services/auth.service"
import { createOnboardingService } from "@/services/onboarding.service"
import { createUserService } from "@/services/user.service"
import { createLiveSetService } from "@/services/liveset.service"

export const useApi = () => {
  const { client } = useApiClient()

  return useMemo(() => ({
    auth: createAuthService(client),
    user: createUserService(client),
    onboarding: createOnboardingService(client),
    liveset: createLiveSetService(client),
   }), [client])
}
